const ProgressBar = ({ step, total }) => {
  const pct = Math.min((step / total) * 100, 100);
  return (
    <div className="relative w-full max-w-180 h-1 rounded-sm bg-black/35 overflow-hidden">
      <div
        className="h-full rounded-sm bg-black transition-all duration-500"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default ProgressBar;
